import React, { useEffect, useState } from "react";
import SportBanner from "./SportBanner";
import SportFilter from "./SportFilter";
import SportResult from "./SportResult";
import { useDispatch, useSelector } from "react-redux";
import { UsePlaceAuth } from "../../../AppContext/AppContext";
import { Things_to_do } from "../../../Redux/Action/Action";
import { apiData } from "../../../actions";
import axios from "axios";

export default function SportIndex() {
  const dispatch = useDispatch();
  const place = useSelector((state) => state.place);
  const { SportsKeyword } = UsePlaceAuth();

  /* ================= STATES ================= */
  const [sportsSideBarAll, setSportsSideBarAll] = useState({});
  const [selectedCheckbox, setSelectedCheckbox] = useState(
    SportsKeyword || ""
  );
  const [sliderData, setSliderData] = useState([]);
  const [scrollComponent, setScrollComponent] = useState(false);

  const [sideBarLoading, setSideBarLoading] = useState(false);
  const [filterLoading, setFilterLoading] = useState(false);
  const [ticketLoading, setTicketLoading] = useState(false);

  const isLoading = sideBarLoading || filterLoading || ticketLoading;

  /* ================= SIDEBAR API ================= */
  useEffect(() => {
    if (!place) return;

    const fetchSidebar = async () => {
      try {
        setSideBarLoading(true);
        const res = await apiData.Sports_Side_Bar({ city: place });

        if (res?.status >= 200 && res?.status <= 399) {
          setSportsSideBarAll(res?.data?.data?.[0] || {});
        } else {
          setSportsSideBarAll({});
        }
      } catch (err) {
        console.error("Sidebar error:", err);
        setSportsSideBarAll({});
      } finally {
        setSideBarLoading(false);
      }
    };

    fetchSidebar();
  }, [place]);

  /* ================= FILTER API ================= */
  const FilterData = async (keyword) => {
    if (!keyword || !place) return;

    try {
      setFilterLoading(true);
      const res = await apiData.get_Sports({
        city: place,
        Keyword: keyword,
      });

      if (res?.status >= 200 && res?.status <= 399) {
        setSliderData(res?.data?.data || []);
      } else {
        setSliderData([]);
      }
    } catch (err) {
      console.error("Filter error:", err);
      setSliderData([]);
    } finally {
      setFilterLoading(false);
    }
  };

  /* ================= FILTER TRIGGER ================= */
  useEffect(() => {
    if (!selectedCheckbox || selectedCheckbox === SportsKeyword) return;
    if (!place) return;

    FilterData(selectedCheckbox);

    return () => {
      dispatch(Things_to_do());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedCheckbox, place]);

  /* ================= TICKETMASTER (DEFAULT) ================= */
  useEffect(() => {
    if (!place) return;
    if (selectedCheckbox && selectedCheckbox !== SportsKeyword) return;

    const fetchTicketmaster = async () => {
      try {
        setTicketLoading(true);
        const res = await axios.get(
          `${process.env.REACT_APP_BASE_URL}ticketmaster?city=${place}&keyword=${SportsKeyword}`
        );
        setSliderData(res?.data?.data || []);
      } catch (err) {
        console.error("Ticketmaster error:", err);
        setSliderData([]);
      } finally {
        setTicketLoading(false);
      }
    };

    fetchTicketmaster();
  }, [SportsKeyword, place, selectedCheckbox]);

  /* ================= SCROLL TO RESULT ================= */
  useEffect(() => {
    if (!scrollComponent || !sliderData?.length) return;

    const target = document.getElementById("items");
    if (target) {
      const y =
        target.getBoundingClientRect().top +
        window.pageYOffset -
        150;
      window.scrollTo({ top: y, behavior: "smooth" });
    }
  }, [sliderData, scrollComponent]);

  /* ================= FILTER CHANGE ================= */
  const handleFilterChange = (value) => {
    setScrollComponent(true);
    setSelectedCheckbox(value || "");
  };

  console.log("Selected:", selectedCheckbox);
  console.log("Sidebar data:", sportsSideBarAll);


  return (
    <>
      <SportBanner />

      <section className="section-equal-padding top-spacing-120 bg-white">
        <div className="container-fluid">
          <div className="row">
            <SportFilter
              sportsSideBarAll={sportsSideBarAll}
              selectedCheckbox={selectedCheckbox}
              onChange={handleFilterChange}
              loading={sideBarLoading}
            />

            <div className="col-12 col-sm-12 col-md-8 col-lg-8 col-xl-8 col-xxl-9">
              <SportResult
                data={sliderData}
                loading={isLoading}
              />
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
